/* ============================================================================
   RVRN Grid Pagination — shared client-side pager for blog-driven grids
   ----------------------------------------------------------------------------
   适用于 rvrn_case_collection_car_events / driving_dreams / case_studies 等
   server-rendered grid：Liquid 一次性渲染（受 grid block 的 limit 限制），
   由本脚本按「每页数量」切页，切换页码时只显隐卡片，不重新请求数据。

   用法（section 侧）：
     1) grid 容器加 data-rvrn-grid
     2) 每张卡片加 data-grid-card
     3) grid 之后紧跟：<nav class="rvrn-grid-pager" data-rvrn-pager
                          data-per-page="6" hidden aria-label="Grid pagination"></nav>
     4) 可选：grid 加 data-featured-class="rvrn-case-card--featured"，
        每页第一张卡片会自动带上该样式类
     5) 若有外部筛选（如 car events 的 filter），筛选后触发
        document.dispatchEvent(new CustomEvent('rvrn:grid:filterchange'))，
        分页会回到第 1 页并重算（仅对非 is-hidden 的卡片分页）

   对外暴露：window.RVRNGridPagination = { init, refresh, refreshAll }
   ========================================================================== */
(function () {
  'use strict';

  var instances = [];

  function fire(el, name) {
    if (!el) return;
    try {
      if (typeof CustomEvent === 'function') {
        el.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      }
    } catch (e) {
      /* noop */
    }
  }

  function Pager(pagerEl) {
    this.pagerEl = pagerEl;

    var grid = pagerEl.previousElementSibling;
    if (!grid || !grid.hasAttribute || !grid.hasAttribute('data-rvrn-grid')) {
      grid = pagerEl.parentNode ? pagerEl.parentNode.querySelector('[data-rvrn-grid]') : null;
    }
    this.gridEl = grid;
    if (!this.gridEl) return;

    this.cards = Array.prototype.slice.call(this.gridEl.querySelectorAll('[data-grid-card]'));
    this.perPage =
      parseInt(pagerEl.getAttribute('data-per-page'), 10) ||
      parseInt(this.gridEl.getAttribute('data-per-page'), 10) ||
      12;
    if (!this.perPage || this.perPage < 1) this.perPage = 1;

    this.featuredClass = this.gridEl.getAttribute('data-featured-class') || '';
    this.currentPage = 1;
    this.totalPages = 1;

    this.bind();
    this.render();
  }

  /* 参与分页的卡片 = 未被外部筛选隐藏（is-hidden）的卡片 */
  Pager.prototype.getActive = function () {
    return this.cards.filter(function (card) {
      return !card.classList.contains('is-hidden');
    });
  };

  Pager.prototype.render = function () {
    var active = this.getActive();
    var totalPages = Math.max(1, Math.ceil(active.length / this.perPage));
    this.totalPages = totalPages;

    if (this.currentPage > totalPages) this.currentPage = totalPages;
    if (this.currentPage < 1) this.currentPage = 1;

    var start = (this.currentPage - 1) * this.perPage;
    var end = start + this.perPage;

    // 先全部隐藏，再显示当前页
    this.cards.forEach(function (card) {
      card.style.display = 'none';
    });
    active.forEach(function (card, i) {
      card.style.display = i >= start && i < end ? '' : 'none';
    });

    // 每页第一张卡片继承 featured 样式（仅当 grid 声明了 data-featured-class）
    if (this.featuredClass) {
      var cls = this.featuredClass;
      active.forEach(function (card) {
        card.classList.remove(cls);
      });
      if (active[start]) active[start].classList.add(cls);
    }

    this.renderPager(totalPages);
    fire(this.gridEl, 'rvrn:grid:paged');
  };

  Pager.prototype.renderPager = function (totalPages) {
    if (!this.pagerEl) return;
    if (totalPages <= 1) {
      this.pagerEl.hidden = true;
      this.pagerEl.innerHTML = '';
      return;
    }
    this.pagerEl.hidden = false;

    var isFirst = this.currentPage <= 1;
    var isLast = this.currentPage >= totalPages;

    this.pagerEl.innerHTML =
      '<button type="button" class="rvrn-btn rvrn-btn--control rvrn-grid-pager__btn rvrn-grid-pager__btn--prev" data-action="prev"' +
      (isFirst ? ' disabled' : '') +
      ' aria-label="Previous page">&#8592; Prev</button>' +
      '<span class="rvrn-grid-pager__indicator" aria-live="polite">' +
      this.currentPage + ' / ' + totalPages +
      '</span>' +
      '<button type="button" class="rvrn-btn rvrn-btn--control rvrn-grid-pager__btn rvrn-grid-pager__btn--next" data-action="next"' +
      (isLast ? ' disabled' : '') +
      ' aria-label="Next page">Next &#8594;</button>';
  };

  Pager.prototype.bind = function () {
    var self = this;
    // 使用事件委托：pager 内容每次 render 会重建，直接绑按钮会失效
    this.pagerEl.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-action]') : null;
      if (!btn || btn.disabled) return;
      var action = btn.getAttribute('data-action');
      if (action === 'prev' && self.currentPage > 1) {
        self.currentPage -= 1;
        self.render();
      } else if (action === 'next' && self.currentPage < self.totalPages) {
        self.currentPage += 1;
        self.render();
      }
    });
  };

  function init(scope) {
    var root = scope || document;
    var pagers = root.querySelectorAll('[data-rvrn-pager]');
    Array.prototype.forEach.call(pagers, function (pagerEl) {
      if (pagerEl.getAttribute('data-rvrn-pager-bound') === 'true') return;
      pagerEl.setAttribute('data-rvrn-pager-bound', 'true');
      instances.push(new Pager(pagerEl));
    });
  }

  /* 外部筛选变化后调用：回到第 1 页并重算 */
  function refreshAll() {
    instances.forEach(function (inst) {
      inst.currentPage = 1;
      inst.render();
    });
  }

  document.addEventListener('rvrn:grid:filterchange', refreshAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.RVRNGridPagination = {
    init: init,
    refresh: refreshAll,
    refreshAll: refreshAll
  };
})();
